module.exports = __webpack_public_path__ + "img/left_3.6c8a509d.jpg";